export default (state, value) => {
	console.info('🦑 SET_SUBMITTING_CLAIMS', { value });
	state.isSubmittingClaims = value;
};
